import domains from 'disposable-email-domains';

const extraBlacklistedDomains = ['webxios.pro', 'bomnet.net'];
//Set for O(1) lookup baby
const allDomains = new Set([...domains, ...extraBlacklistedDomains]);

export function validateEmail(email: string): boolean {
    const e = email.trim().toLowerCase();
    const re = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    if (!re.test(e)) return false;

    const domain = e.split('@')[1];
    return !allDomains.has(domain);
}
